import React from 'react';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-name">김기조 · Kim Ki-jo · 1949–</div>
      <div className="footer-copy">© 2025 Family Archive · All rights reserved</div>
    </footer>
  );
}

export default Footer;